import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [bookingId, setBookingId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    let timer;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setBookingId(data.booking_id);
          setTimeout(() => data.booking_id && navigate(`/confirmation/${data.booking_id}`), 1200);
          return;
        }
      } catch (e) { /* ignore */ }
      if (attempts >= 20) { setStatus("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => timer && clearTimeout(timer);
  }, [sessionId, navigate]);

  return (
    <div className="pt-32 pb-16 max-w-2xl mx-auto px-4 text-center" data-testid="payment-success-page">
      {status === "polling" && (
        <>
          <Loader2 className="w-10 h-10 text-amber-600 mx-auto animate-spin" />
          <h1 className="mt-6 text-3xl font-bold text-slate-900">Confirming your payment…</h1>
          <p className="mt-2 text-slate-600">Hang tight — we're checking with Stripe.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" />
          <h1 className="mt-6 text-3xl font-bold text-slate-900">Parts paid — you're booked!</h1>
          <p className="mt-2 text-slate-600">Redirecting to your confirmation…</p>
        </>
      )}
      {status === "timeout" && (
        <>
          <h1 className="mt-6 text-3xl font-bold text-slate-900">Still processing…</h1>
          <p className="mt-2 text-slate-600">
            Your payment is taking longer than usual. You'll get an email once it clears.
          </p>
        </>
      )}
    </div>
  );
}
